import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6a0f7648")

_pushScopeId("data-v-6a0f7648")
const _hoisted_1 = { class: "shopItem" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "fs_13 grey text-capitalize" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "fs_14 greyBlue" }
const _hoisted_6 = { class: "fs_14 spaceCadet" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "imageContainer",
      style: 'background-image: url(\'' + _ctx.model.thumbnailUrl + '\');'
    }, null, 4),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", null, [
        _createVNode("h2", null, _toDisplayString(_ctx.model.title), 1),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.model.variation.variations, (dic, key) => {
          return (_openBlock(), _createBlock("div", {
            key: key,
            class: "ln_12"
          }, [
            _createVNode("span", _hoisted_3, _toDisplayString(key) + ": " + _toDisplayString(dic), 1)
          ]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, [
          _createVNode(_component_localized_text, {
            localizedKey: 'app_qt',
            text: 'Qt.'
          }, null, 8, ["text"]),
          _createTextVNode(" " + _toDisplayString(_ctx.model.amount), 1)
        ]),
        _createVNode("span", _hoisted_6, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.model.variation.price)), 1)
      ])
    ])
  ]))
})